import { Component, ContentChild, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'split-abbreviation-text',
  templateUrl: './abbreviation-text.component.html',
  styleUrls: ['./abbreviation-text.component.scss']
})
export class AbbreviationTextComponent {
  @ContentChild('content' , {static: true}) content !: ElementRef;

}
